"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyStatusPacingToJSON = exports.SurveyStatusPacingFromJSONTyped = exports.SurveyStatusPacingFromJSON = exports.SurveyStatusPacing = void 0;
/**
 *
 * @export
 */
exports.SurveyStatusPacing = {
    QuestionPacingUnspecified: 'QUESTION_PACING_UNSPECIFIED',
    UnderPacing: 'UNDER_PACING',
    OnTrack: 'ON_TRACK'
};
function SurveyStatusPacingFromJSON(json) {
    return SurveyStatusPacingFromJSONTyped(json, false);
}
exports.SurveyStatusPacingFromJSON = SurveyStatusPacingFromJSON;
function SurveyStatusPacingFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SurveyStatusPacingFromJSONTyped = SurveyStatusPacingFromJSONTyped;
function SurveyStatusPacingToJSON(value) {
    return value;
}
exports.SurveyStatusPacingToJSON = SurveyStatusPacingToJSON;
